import moment from 'moment'

export default {
  // Inhalt des Modals
  model: {
    id: 0,
    name: '',
    firstname: '',
    lastname: '',
    birthname: '',
    birthday: null,
    dyingday: null,
    burial: null,
    mourning: null,
    grave: '',
    gender: 0,
    deceased_id: 0,
    area: '',
    undertaker_id: 0,
    crematory_id: 0,
    undertaker_name: '',
    crematory_name: '',
    urn_number: '',
    burial_type: '',
    denomination: '',
    denomination_id: 0,
    birthplace: '',

    // Wichtig für Relations
    from: null,
    until: null
  },

  name: 'deceaseds',

  // Die Spalten der Tabelle
  cols: [
    {name: 'Name', json: 'name', type: 'text'},
    {name: 'Geburtstag', json: 'birthday', type: 'date', 'colCSS': 'hidden-xs'},
    {name: 'Todestag', json: 'dyingday', type: 'date', 'colCSS': 'hidden-xs'},
    {name: 'Grabstätte', json: 'grave', type: 'text'},
    {name: 'Fläche', json: 'area', type: 'text'}
  ],

  relations: [
    'graves',
    'customers',
    'crematories',
    'undertakers',
    'burial_types',
    'denominations',
    'address_types',
    'zips'
  ],

  copy (aModel) {
    this.model.id = aModel.id
    this.model.firstname = aModel.firstname
    this.model.lastname = aModel.lastname
    this.model.birthname = aModel.birthname
    this.model.gender = aModel.gender
    this.model.birthday = aModel.birthday
    this.model.dyingday = aModel.dyingday
    this.model.burial = aModel.burial
    this.model.mourning = aModel.mourning
    this.model.undertaker_id = aModel.undertaker_id
    this.model.undertaker_name = aModel.undertaker_name
    this.model.urn_number = aModel.urn_number
    this.model.crematory_name = aModel.crematory_name
    this.model.crematory_id = aModel.crematory_id
    this.model.burial_type = aModel.burial_type
    this.model.burial_type_id = aModel.burial_type_id
    this.model.denomination = aModel.denomination
    this.model.denomination_id = aModel.denomination_id
    this.model.birthplace = aModel.birthplace

    this.model.name = aModel.deceased_id + ': ' + aModel.name
    this.model.grave = aModel.grave
    this.model.deceased_id = aModel.deceased_id

    // Wichtig für Relations
    this.model.from = aModel.from
    this.model.until = aModel.until
  },

	validate () {
		const parts = this.model.name.split(':')

		this.model.deceased_id = parts[0]
		this.model.deceased_id = parseInt(this.model.deceased_id)
		this.model.from = moment(this.model.from, 'YYYY-MM-DD').toISOString()
		this.model.until = moment(this.model.until, 'YYYY-MM-DD').toISOString()

		this.model.gender = parseInt(this.model.gender)

		this.model.denomination_id = parseInt(this.model.denomination_id)

		return true
	},

	validateModel () {
		return this.model.firstname !== '' &&
			this.model.lastname !== '' &&
			this.model.birthday !== null &&
			this.model.dyingday !== null &&
			!isNaN(parseInt(this.model.denomination_id))
	},

	clear () {
		this.model.id = 0
		this.model.name = ''
		this.model.from = moment(Date.now()).format('YYYY-MM-DD')
		this.model.until = moment(moment(Date.now()).add(25, 'years')).format('YYYY-MM-DD')
		this.model.grave = ''
		this.model.gender = 0

		this.model.firstname = ''
		this.model.lastname = ''
		this.model.birthname = ''
		this.model.birthday = null
		this.model.dyingday = null
		this.model.burial = null
		this.model.mourning = null
		this.model.grave = ''
		this.model.gender = 0
		this.model.deceased_id = 0
		this.model.urn_number = ''
		this.model.undertaker_id = 0
		this.model.undertaker_name = ''
		this.model.crematory_id = 0
		this.model.crematory_name = ''
		this.model.burial_type = ''
		this.model.burial_type_id = 0
		this.model.denomination = ''
		this.model.denomination_id = 0
		this.model.birthplace = ''

		this.graves = []
		this.customers = []
	},

	clearModel () {
		this.model.id = 0
		this.model.name = ''
		this.model.from = null
		this.model.until = null
		this.model.grave = ''
		this.model.gender = 0

		this.model.firstname = ''
		this.model.lastname = ''
		this.model.birthname = ''
		this.model.birthday = null
		this.model.dyingday = null
		this.model.burial = null
		this.model.mourning = null
		this.model.grave = ''
		this.model.gender = 0
		this.model.deceased_id = 0
		this.model.urn_number = ''
		this.model.undertaker_id = 0
		this.model.undertaker_name = ''
		this.model.crematory_id = 0
		this.model.crematory_name = ''
		this.model.burial_type = ''
		this.model.burial_type_id = 0
		this.model.denomination = ''
		this.model.denomination_id = 0
		this.model.birthplace = ''

		this.graves = []
		this.customers = []
	},

  // Beziehungen zu anderen Models
  graves: [],
  customers: [],
  addresses: []
}



// WEBPACK FOOTER //
// ./src/models/deceaseds.js